<div>
    <app-icon ic="IcTrash" size="s" color="var(--color-primary-60)" (click)="deleteBtnAction()"></app-icon>
    <app-icon ic="IcTime" size="s" color="var(--color-primary-50)" (click)="timeBtnAction()"></app-icon>
</div>
